import { HttpClient } from 'api/http-client';

export enum CustomerPortalInviteMethod {
  EmailsFromCustomerDomainsAndAdditionalDomains = 'EMAILS_FROM_CUSTOMER_DOMAINS_AND_ADDITIONAL_DOMAINS',
  AnyoneWithTheLink = 'ANYONE_WITH_THE_LINK',
}

export interface CustomerPortalInviteMethodMeta {
  userWithPermissionCanInviteCustomers?: boolean;
  customerCanBeAddedViaJWT?: boolean;
}

export enum AccountCustomerPortalType {
  Old = 'OLD',
  New = 'NEW',
}

export interface AccountCustomerPortalSettings {
  publicKey?: string | null;
  sharedSecret?: string | null;
  algorithm: CustomerPortalSettingsAlgorithm;
  mechanism: CustomerPortalSettingsMechanism;
  createdAt?: number;
  updatedAt?: number;
  createdBy?: number;
  updatedBy?: number;
  accountCustomerPortalSettingsId?: number;
  inviteMethod: CustomerPortalInviteMethod;
  inviteMethodMeta: CustomerPortalInviteMethodMeta;
  portalType: AccountCustomerPortalType;
  defaultPortalId?: number;
}

export interface CustomerPortalSettingsRequestAndResponse {
  customerPortalSettings: AccountCustomerPortalSettings;
}

export enum CustomerPortalSettingsAlgorithm {
  RS256 = 'RS256',
  HS256 = 'HS256',
}

export enum CustomerPortalSettingsMechanism {
  SharedSecret = 'SHARED_SECRET',
  PublicPrivateKeyPair = 'PUBLIC_PRIVATE_KEY_PAIR',
}

export interface CustomerPortalSecretKeyGenerationRequest {
  algorithm: CustomerPortalSettingsAlgorithm;
}

export interface CustomerPortalSecretKeyGenerationResponse {
  secretKey: string;
}

class AccountCustomerPortalSettingsHttpClient extends HttpClient {
  public getCustomerPortalsSettingsForAccount() {
    return this.get<CustomerPortalSettingsRequestAndResponse>(
      '/settings/customer-portal/',
    );
  }

  public updateCustomerPortalsSettingsForAccount(
    payload: Partial<CustomerPortalSettingsRequestAndResponse>,
  ): Promise<CustomerPortalSettingsRequestAndResponse> {
    return this.post('/settings/customer-portal/', payload);
  }

  public switchToNew(): Promise<CustomerPortalSettingsRequestAndResponse> {
    return this.post('/settings/customer-portal/switch-to-new');
  }

  public generateSecretKey(
    payload: CustomerPortalSecretKeyGenerationRequest,
  ): Promise<CustomerPortalSecretKeyGenerationResponse> {
    return this.post('/settings/customer-portal/generate-secret', payload);
  }
}

export const CustomerPortalSettingsApi =
  new AccountCustomerPortalSettingsHttpClient();
